import { render, staticRenderFns } from "./Task.vue?vue&type=template&id=6d0a6943&scoped=true"
import script from "./Task.vue?vue&type=script&lang=ts"
export * from "./Task.vue?vue&type=script&lang=ts"
import style0 from "./Task.vue?vue&type=style&index=0&id=6d0a6943&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0a6943",
  null
  
)

export default component.exports